const cardBodyStyle = {
  cardBody: {
    padding: "0 20px",
    flex: "1 1 auto",
    WebkitBoxFlex: "1",
    position: "relative",
    paddingBottom:"5px"
  },
  cardBodyPlain: {
    paddingLeft: "5px",
    paddingRight: "5px",
  },
  cardBodyProfile: {
    marginTop: "15px",
  },
};

export default cardBodyStyle;
